import React from 'react';
import './QueueBar.css';

// Minimal full-page overlay spinner. No textual queue info — only a spinner.
export default function QueueBar({ total = 0 }) {
  if (!total || total <= 0) return null;

  return (
    <div className="qc-overlay" role="status" aria-live="polite">
      <div className="qc-backdrop" />
      <div className="qc-center" aria-hidden>
        <div className="qc-spinner" />
      </div>
    </div>
  );
}
